import { render, staticRenderFns } from "./PContentContainer.vue?vue&type=template&id=1e242c66&scoped=true"
import script from "./PContentContainer.vue?vue&type=script&lang=js"
export * from "./PContentContainer.vue?vue&type=script&lang=js"
import style0 from "./PContentContainer.vue?vue&type=style&index=0&id=1e242c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e242c66",
  null
  
)

export default component.exports